/* eslint-disable */
// @ts-nocheck
import { createI18n, type I18nOptions } from 'vue-i18n'
import { nextTick } from 'vue'
import { default as svMessages } from '../locales/sv.json'
import { default as enMessages } from '../locales/en.json'
import vuetify from './vuetify'
import * as vuetifyLocales from 'vuetify/locale'

export type MessageSchema = typeof svMessages

declare module 'vue-i18n' {
  export interface DefineLocaleMessage extends MessageSchema {}

  export interface DefineDateTimeFormat {
    short: {
      hour: 'numeric'
      minute: 'numeric'
      second: 'numeric'
      timeZoneName: 'short'
      timezone: string
    }
  }

  export interface DefineNumberFormat {
    currency: {
      style: 'currency'
      currencyDisplay: 'symbol'
      currency: string
    }
  }
}

const localeImports = import.meta.glob<{ default: Record<string, string> }>('../locales/*.json')

export const supportedLocales = Object.keys(localeImports).map((path) => path.split('/').at(-1)?.replace('.json', ''))

export async function setLocale(locale: string) {
  if (!i18n.global.availableLocales.includes(locale)) {
    if (!supportedLocales.includes(locale)) {
      throw new TypeError(`Unsupported locale requested ${locale}`)
    }
    console.log('Loading locale', locale)

    i18n.global.setLocaleMessage(locale, {
      ...messages.default,
      $vuetify: {
        ...(Object.hasOwn(vuetifyLocales, locale) ? vuetifyLocales[locale] : {}),
        ...(typeof messages.default.$vuetify === 'object' && messages.default.$vuetify !== null
          ? messages.default.$vuetify
          : {}),
      },
    })
  }

  await nextTick()
  if (i18n.mode === 'legacy') {
    ;(i18n.global.locale as unknown as string) = locale
  } else {
    i18n.global.locale.value = locale
  }
  localStorage.setItem('locale', locale)
  vuetify.locale.current.value = locale
}

const options: I18nOptions = {
  locale: localStorage.getItem('locale') ?? import.meta.env.VITE_APP_I18N_LOCALE ?? 'sv',
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE ?? 'en',
  missingWarn: false,
  fallbackWarn: false,
  messages: {
    sv: svMessages,
    en: enMessages,
  },
}

const i18n = createI18n<false, typeof options>(options)

void setLocale(localStorage.getItem('locale') ?? import.meta.env.VITE_APP_I18N_LOCALE ?? 'sv')

export default i18n
